import { useState, useEffect } from 'react';

const MuestraSecciones = ({ sede, devuelve }) => { // Sede se pasa como prop
    const [companias, setCompanias] = useState([]);
    const [filterId, setFilterId] = useState(''); // Estado para el filtro por ID

    const pideSecciones = async () => {
        fetch('https://wwwa.isepsantafe.net.ar/expedientes/devuelveSecciones', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        })
        .then(response => response.json())
        .then(data => {
            const agrupadas = data.reduce((acc, item) => {
                const { Compania, nombre, descripcion } = item;
                const companiaNombre = Compania?.nombre || `Compañía ${item.compania.nombre}`;

                if (!acc[companiaNombre]) {
                    acc[companiaNombre] = [];
                }

                // Agregar el 'id' de la sección como parte del objeto
                acc[companiaNombre].push({ id: item.id, companiaId: Compania?.id, nombre, descripcion });
                return acc;
            }, {});

            setCompanias(agrupadas);
        })
        .catch(error => console.error('Error al cargar secciones:', error));
    };

    useEffect(() => {
        pideSecciones();
    }, []);

    const handleClick = async (seccion) => {
        devuelve(seccion)
    };

    // Definir las compañías a mostrar según la sede
    const filterBySede = (companiaId) => {
        if (sede === 2) {
            return [2, 3, 4].includes(companiaId);
        }
        if (sede === 3) {
            return [5, 6, 7].includes(companiaId);
        } else {
            return [2, 3, 4, 5, 6, 7, 8].includes(companiaId);
        }
    };

    // Filtrar las compañías si hay un filtro aplicado
    const filteredCompanias = Object.entries(companias).filter(([compania, secciones]) =>
        secciones.some(seccion =>
            (seccion.id.toString().includes(filterId) && filterBySede(seccion.companiaId))
        )
    );

    return (
        <div style={{ textAlign: "center", display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
                {filteredCompanias.map(([compania, secciones], index) => {
                    // Asignar color basado en el id de la compañía
                    const companiaId = secciones[0].companiaId; // Usar companiaId
                    let backgroundColor;
                    let colorBa;
                    switch (companiaId) {
                        case 2:
                            backgroundColor = '#015424'; // Color para ID 2 (Ejemplo)
                            colorBa = 'white';
                            break;
                        case 3:
                            backgroundColor = 'red'; // Color para ID 3 (Ejemplo)
                            colorBa = 'white';
                            break;
                        case 4:
                            backgroundColor = '#ff1493'; // Color para ID 4 (Ejemplo)
                            colorBa = 'white';
                            break;
                        case 6:
                            backgroundColor = '#00008b'; // Color para ID 5 (Ejemplo)
                            colorBa = 'white';
                            break;
                        case 7:
                            backgroundColor = '#ffff00'; // Color para ID 6 (Ejemplo)
                            break;
                        case 8:
                            backgroundColor = '#8b4513'; // Color para ID 7 (Ejemplo)
                            break;
                        default:
                            backgroundColor = '#eee'; // Color por defecto
                            break;
                    }

                    return (
                        <div
                            key={index}
                            style={{
                                background: backgroundColor,
                                color: colorBa,
                                padding: '10px',
                                borderRadius: '10px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}
                        >
                            <h6>{compania}</h6>
                            {secciones.map((seccion, i) => (
                                <button
                                    key={i}
                                    onClick={() => handleClick(seccion)} // Pasa todo el objeto de la sección
                                    style={{
                                        display: 'block',
                                        margin: '10px 0',
                                        padding: '10px 10px',
                                        textAlign: 'center',
                                        borderRadius: "20px",
                                        border: "1px solid black"
                                    }}
                                >
                                    {seccion.nombre} ({seccion.descripcion})
                                </button>
                            ))}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MuestraSecciones;
